class ClientError extends Error {
  constructor(message, { request, response, cause }) {
    super(message, { cause });

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ClientError);
    }

    this.request = request;
    this.response = response;
  }
}

export default ClientError;
